<template>
  <v-container fluid>
    <h2>
      {{ $t('create_user') }}
    </h2>
    <user-form/>
  </v-container>
</template>

<script>

import UserForm from '@/components/user/UserForm'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'

export default {
  name: 'UserCreate',
  components: { UserForm },
  mixins: [BrowserUtilitiesMixin],
  mounted() {
    this.updateBrowserTitle(this.$t('create_user'))
  }
}

</script>

<style scoped>

</style>
